import TabsHelper from './helpers/tabs-helper';

export default class USPTabs {
  constructor() {
    this.el = document.querySelector('.tabs-usp');
    this.init();
  }

  init() {
    if (!this.el) return;

    this.closeTabButtons = this.el.querySelectorAll('.close-tab');

    this.addEventListeners();
  }

  addEventListeners() {
    this.closeTabButtons.forEach((closeTabButton) => {
      closeTabButton.addEventListener('click', (event) => this.handleCloseButton(event));
    });

    const mq = window.matchMedia('(max-width: 992px)');
    if (mq.matches) {
      const firstTab = this.el.querySelector('.nav-tabs .nav-item:first-child > .nav-link');
      const firstPanel = this.el.querySelector('.tab-content .tab-pane:first-child');

      TabsHelper.deactivateTab(firstTab, firstPanel);
    }
  }

  handleCloseButton(event) {
    const currentTabPane = event.currentTarget.closest('.tab-pane');
    const activeTab = this.el.querySelector(`[data-bs-toggle=tab][href="#${currentTabPane.id}"]`);

    TabsHelper.deactivateTab(activeTab, currentTabPane);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  /* eslint-disable no-new */
  new USPTabs();
});
